import { createUserHttpRepository } from '@src/main/modules/user/infrastructure/UserHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const deleteUserUseCase = async (
  id: string,
  tokenProvider: TokenProvider,
): Promise<void> => {
  const repository = createUserHttpRepository(tokenProvider);
  await repository.delete(id);
};
